import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politica-tratamiento-de-datos',
  templateUrl: './politica-tratamiento-de-datos.component.html',
  styleUrls: ['./politica-tratamiento-de-datos.component.scss']
})
export class PoliticaTratamientoDeDatosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
